import { render, staticRenderFns } from "./CurrentHoldingsTableV2.vue?vue&type=template&id=424f88f5&scoped=true"
import script from "./CurrentHoldingsTableV2.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldingsTableV2.vue?vue&type=script&lang=ts"
import style0 from "./CurrentHoldingsTableV2.vue?vue&type=style&index=0&id=424f88f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f88f5",
  null
  
)

export default component.exports